import { render, staticRenderFns } from "./FormControl.vue?vue&type=template&id=45f10d4f&"
import script from "./FormControl.vue?vue&type=script&lang=ts&"
export * from "./FormControl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports